import React, { Component } from "react";

import "../../App.css";

class StripeOnboardingRefresh extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount = async () => {
  }

  render = () => {
    if (window.ReactNativeWebView) {
      var data = {
        type: "onboarding_refresh",
      };
      window.ReactNativeWebView.postMessage(JSON.stringify(data));
    }

    return (
      <div className="App">
      </div>
    );
  }
}

export default StripeOnboardingRefresh;
